import { hookstate } from "@hookstate/core";
import {
  InitResponsePayloadResults,
  ComicFacetGroupOptionEntity,
  ComicUserReadingStatusEntity,
} from "../services/gc/types";

export type AppState = {
  init: InitResponsePayloadResults;
  facetGroupMap: Record<number, ComicFacetGroupOptionEntity>;
  countryFlagMap: Record<string, string>;
  readingStatusMap: Record<number, ComicUserReadingStatusEntity>;
};

// Used for state that should be shared across screens.
// `init` defaults seed the array/map fields consumers iterate over
// (`comic_facet_groups`, `languages`, `countries`, …) so .find/.filter calls
// during the brief window before /v1/app/init resolves don't throw. Scalar
// fields (`app_urls`, etc.) stay undefined — callers either check them or
// only read them after init is populated.
export const appStore = hookstate<AppState>({
  init: {
    comic_facet_groups: [],
    languages: [],
    countries: [],
    comic_user_reading_statuses: [],
  } as unknown as InitResponsePayloadResults,
  facetGroupMap: {},
  countryFlagMap: {},
  readingStatusMap: {},
});
